module.exports = g_errBase;